import React from "react";
import GiftCard from "../../components/gift/GiftCard";
import { makeStyles, Container, Grid, Typography } from "@material-ui/core";
import Title from "../../components/about/common/Title";

const useStyles = makeStyles(() => ({
  root: {
    textAlign: "center",
    marginBottom: "5rem",
  },
  priceTitle: {
    margin: "6.312rem 0 3.625rem 0",
  },
}));

const Gift = () => {
  const classes = useStyles();

  const data = [
    ["$ 15.00", "$ 70.00", "$ 130.00"],
    ["1 HOUR", "5 HOURS", "10 HOURS"],
    [],
  ];

  return (
    <div className={classes.root}>
      <Title title="Buy the gift of conversation today!" />

      <Container>
        <Grid container spacing={3}>
          {data.map((d, i) => (
            <Grid item md={4} xs={12} key={i}>
              <GiftCard
                price={data[0][i]}
                hour={data[1][i]}
                text="Gift of Conversation"
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
};

export default Gift;
